import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api.urls';
import { ClientPartner } from '../_models/client-partner';

@Injectable({
    providedIn: 'root'
})
export class ClientPartnerService {

    constructor(private httpClient: HttpClient) { }

    loadAll(): Observable<ClientPartner[]> {
        return this.httpClient.get<ClientPartner[]>(API_URLS.CLIENT_PARTNERS);
    }

    loadAllAdmin(): Observable<any> {
        return this.httpClient.get(API_URLS.SECURE_CLIENT_PARTNERS);
    }

    loadOne(id: string): Observable<ClientPartner> {
        return this.httpClient.get<ClientPartner>(API_URLS.SECURE_CLIENT_PARTNERS + '/' + id);
    }

    save(clientPartner: ClientPartner, logo: Blob) {
        if (!clientPartner.id) {
            return this.add(clientPartner, logo);
        } else {
            return this.update(clientPartner, logo);
        }
    }

    add(clientPartner: ClientPartner, logo: Blob) {
        return this.httpClient.post(API_URLS.SECURE_CLIENT_PARTNERS, this.buildFormData(clientPartner, logo));
    }

    update(clientPartner: ClientPartner, logo: Blob) {
        return this.httpClient.put(API_URLS.SECURE_CLIENT_PARTNERS + '/' + clientPartner.id, this.buildFormData(clientPartner, logo));
    }

    delete(id: string) {
        return this.httpClient.delete(API_URLS.SECURE_CLIENT_PARTNERS + '/' + id);
    }

    private buildFormData(clientPartner: ClientPartner, logo: any) {
        const formData = new FormData();
        if (logo) {
            formData.append('file', logo);
        }
        const dataBlob = new Blob(
            [JSON.stringify({ clientPartnerName: clientPartner.clientPartnerName })],
            { type: 'application/json' }
        );
        formData.append('data', dataBlob);
        return formData;
    }
}
